module.exports = __webpack_public_path__ + "static/leaf-2-8ae817f6e0f5d4c1246b3660af0e0834.png";